module.exports = __webpack_public_path__ + "img/docusign-REI.3cf288ac.png";